import { useMutation } from '@tanstack/react-query';

import { ExcludeCampaignPosts } from '../api';
import { useInvalidateAllCampaigns } from './use-invalidate-all-campaigns';

type ExcludeCampaignPostsMutationRequest = {
  campaignId: string;
  postIds: string[];
};

export const useExcludeCampaignPostsMutation = () => {
  const invalidateAllCampaigns = useInvalidateAllCampaigns();

  return useMutation({
    mutationFn: ({ campaignId, postIds }: ExcludeCampaignPostsMutationRequest) =>
      ExcludeCampaignPosts(campaignId, { campaign_post_ids: postIds }),
    onSuccess: async (_data, { campaignId }) => {
      await invalidateAllCampaigns({ campaignId, includeDetail: true, includeMetrics: true });
    },
  });
};
